import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
import {ListingTitle} from "./ListingTitle";
import {ListingProviderAndImage} from "./ListingProviderAndImage";
import {listing} from "./listing-props";
import {ListingSummary} from "./ListingSummary";

export class ListingFoundVsExpected extends Component {
  static propTypes = {
    listing: PropTypes.object.isRequired
  };

  render() {
    const {listing} = this.props;
    const {expectedLocation, expectedURL, foundLocation, foundURL} = listing;
    return (
      <div className="row">
        <div className="col-sm-4">
          <ListingProviderAndImage listing={listing}/>
        </div>
        <div className="col-sm-8">
          <div className="row">
            <div className="col-sm-6">
              <ListingTitle title="Found Listing"/>
              <ListingSummary listing={{...foundLocation, website: foundURL, listingURL: listing.listingURL}} matchErrors={listing.matchErrors}/>
            </div>
            <div className="col-sm-6">
              <ListingTitle title="Expected Listing"/>
              <ListingSummary listing={{...expectedLocation, website: expectedURL}}/>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <hr />
              <ListingDetails listing={listing}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class ListingDetails extends React.Component {
  static propTypes = {
    listing: listing.isRequired
  }

  render() {
    const {listing: {
      categories,
      listingURL,
      description
    }} = this.props
    const na = <span className="text-muted">N/A</span>;
    return <Fragment>
      <div>
        <strong>Description:</strong> {description || na}
      </div>
      <div>
        <strong>Categories:</strong> {categories && categories.length ? categories.join(', ') : na}
      </div>
      <div className="listings-clip-url">
        <strong>Listing URL: </strong> {listingURL ? <a href={listingURL} target="_blank">{listingURL}</a> : na}
      </div>
    </Fragment>
  }
}